import SlidePrev from './SlidePrev'

export default SlidePrev
// eslint-disable-next-line import/export
export * from './SlidePrev'
